export const feedPage = {
    'feed.page.feed.tab.posts': 'Posts',
    'feed.page.feed.tab.toys': 'Toys',
    'feed.page.feed.tab.digital': 'Digital',
    'feed.page.feed.tab.physical': 'Physical',
    'feed.page.toys.placeholder': 'Enter toy name',
    'feed.page.artists.placeholder': 'Enter artist name',
    'feed.page.posts.placeholder': 'Enter post name',
}
